export const environment = {
  production: false,
  serverUrl: "https://demo-api.simaubenin.com/api",
  publicUrl: "https://demo-api.simaubenin.com",

  // serverUrl: "https://zenapi-api.simaubenin.com/api",
  // publicUrl: "https://zenapi-api.simaubenin.com",

  // serverUrl: "http://127.0.0.1:8000/api",
  // publicUrl: "http://127.0.0.1:8000",
  mercureUrl: "https://zenapi-mercure.herokuapp.com/.well-known/mercure",

  // Clés API pour les cartes
  googleMapsApiKey: "AIzaSyCR7wdbPJRZh49cZ5lq_LCw-Eb0CFNSCdI",
  mapboxAccessToken: "pk.eyJ1Ijoia2FrYXNoaWhhdGFrZTIzIiwiYSI6ImNsaXU5cTdpaTAxMDEzZXM2cGtqb2t1bjAifQ.P9JjnJpCXSdWVaY0-DMVhg"
};
